<template>
  <div id="footer" class="container-fluid">
    <div class="page-footer-inner">
      <div class="left-wrap">
        <div class="left-title">联系我们</div>
        <div class="item">
          <!-- <div><span>公司名称: </span>湖北众邦消防技术有限公司</div> -->
          <div><span>联系电话: </span>027-87869119</div>
          <div><span>公司官网: </span>www.zbxf100.com</div>
          <div><span>公司邮箱: </span>zbxf100@163.com</div>
          <div><span>公司地址: </span>武汉市洪山区书城路26号洪山科创中心B栋604室</div>
        </div>
      </div>
      <div class="right-wrap">
        <div class="qr-code-list">
          <img src="@/assets/img/21746686305_.pic.png" alt="">
          <p class="qr-code-title">公众号</p>
        </div>
        <div class="qr-code-list">
          <img src="@/assets/img/WechatIMG8.png" alt="">
          <p class="qr-code-title">官方微信</p>
        </div>
        <div class="qr-code-list">
          <img src="@/assets/img/31746686306_.pic.png" alt="">
          <p class="qr-code-title">众邦消防</p>
        </div>
        <div class="qr-code-list">
          <img src="@/assets/img/41746686306_.pic.png" alt="">
          <p class="qr-code-title">众邦消防小课堂</p>
        </div>
      </div>
    </div>
    <div class="el-divider">
    </div>
    <p>版权所有 ©{{ newDate }} 湖北众邦消防技术有限公司鄂ICP备2025110139号</p>
    <!-- <div class="logo">
      <img src="@/assets/img/v-logo.png" class="logo-img" alt="logo图">
    </div>
    <p class="title">湖北众邦消防技术有限公司</p>
    <p class="address_tel_fax">
      <span>地址：湖北省武汉市洪山区书城路26号洪山科技创业中心B栋604室</span>
      <span>Tel：027-8786-9119</span>
    </p>
    <p class="email_wx">
      <span>邮箱：zbxf100@163.com</span>
    </p>
    <p class="copy">Copyright &copy; 2018 - {{ new Date().getFullYear() }} 湖北众邦消防技术有限公司</p> -->
  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {
      newDate: new Date().getFullYear()
    };
  }
};
</script>
<style scoped lang="scss">
.container-fluid {
  background-color: #f3f4f8;
  padding: 50px 15% 20px 15%;

  .page-footer-inner {
    display: flex;
    justify-content: space-between;

    .left-wrap {
      .left-title {
        font-size: 18px;
        color: #41454b;
        font-weight: 700;
        margin-bottom: 10px
      }

      .item {
        font-size: 16px;
        color: #707681;
        // display: flex;
      }
    }

    .right-wrap {
      display: flex;

      .qr-code-list {
        margin-right: 30px;

        .qr-code-title {
          margin-top: 10px;
          color: #707681;
          text-align: center;
        }

        img {
          display: block;
          width: 134px;
          height: 134px;
          padding: 15px;
          border-radius: 10px; // 圆角;
          border: 2px solid #cccccc;
        }
      }

      .qr-code-list:last-child {
        margin-right: 0;
      }
    }

    h3 {
      font-size: 18px;
      color: #41454b;
      font-weight: bold;
    }

    a {
      color: #707681;
    }

    a:hover {
      color: #2256fd;
    }
  }

  .el-divider {
    border-top: 1px solid #d3d3d3;
    margin: 24px 0;
  }

  p {
    color: #707681;
    font-size: 16px;
  }
}

// #footer {
//   width: 100%;
//   height: 100%;
//   color: #fff;
//   background: #474747;
//   overflow: hidden;
//   text-align: center;
// }

.logo {
  width: 94px;
  height: 80px;
  margin: 50px auto 20px;
}

.logo-img {
  width: 94px;
  height: 80px;
}

.title {
  font-size: 25px;
  margin-bottom: 20px;
}

.address_tel_fax {
  color: #d3d3d3;
  font-size: 14px;
  margin: 10px 0;
}

.email_wx {
  color: #d3d3d3;
  font-size: 14px;
}

.copy {
  color: #d3d3d3;
  font-size: 14px;
  margin: 50px 0 10px;
}

@media screen and (max-width: 997px) {
  .title {
    font-size: 20px;
  }

  .address_tel_fax {
    font-size: 12px;
  }

  .email_wx {

    font-size: 12px;
  }

  .copy {
    font-size: 12px;
    margin: 30px 0 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue